"use strict";

import React, {Fragment} from 'react';
import OrderShipment from "./OrderShipment";
import SvgLeavePageIcon from "../../component/SvgLeavePageIcon";
import dateFormat from "dateformat";
import {myTimestampToDate} from "../../time";

const OrderShipments = ({shipments=[]}) => {
    if(shipments.length){
        return (
            <ul className="display__table table--rows-bordered"
                style={{listStyle: 'none', borderCollapse: 'collapse', marginLeft: '0', }} >
                <li className="display__table__head">
                    <div className="display__table__cell">
                        Service
                    </div>
                    <div className="display__table__cell">
                        Tracking
                    </div>
                    <div className="display__table__cell">
                        Ship Date
                    </div>
                </li>
            { shipments.map( shipment => <OrderShipment key={shipment.id} shipment={shipment}/> ) }
            </ul>
        );
    }
    return null;
};

export default OrderShipments;